import Api from '../api/Api';
export var RECEIVE_USER_RATINGS = 'RECEIVE_USER_RATINGS';
export function receiveUserRatingsAction(userId, userRatings) {
    return {
        type: RECEIVE_USER_RATINGS,
        userId: userId,
        userRatings: userRatings
    };
}
export function fetchUserRatings(userId) {
    return function (dispatch) {
        return Api.Rating.getRatings(userId).then(function (response) {
            return dispatch(receiveUserRatingsAction(userId, response));
        });
    };
}
